import { Dictionary, Product, RepoState } from 'typings/repo';
import { ConfigurationState } from 'typings/configuration';
import { getConfigurationProducts } from 'helpers/configurationHelper';
import { getProduct } from 'state/repo';
import { isDiscount, getDiscountPriceKey } from "./discountHelpers";

export const getPrice = (configuration: ConfigurationState, repo: RepoState, currency: string, lang: string, extra1?: Dictionary<number>, extra2?: Dictionary<number>, discount?: boolean) => {
  var parts = getConfigurationProducts(configuration, repo);
  var price = getPartsPrice(parts, repo, currency, discount);
  if (extra1) price += getPartsPrice(extra1, repo, currency, discount);
  if (extra2) price += getPartsPrice(extra2, repo, currency, discount);

  return isWholeNumber(price) ?
    price.toLocaleString(lang) :
    price.toLocaleString(lang, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export const getPriceNumeric = (configuration: ConfigurationState, repo: RepoState, currency: string, extra1?: Dictionary<number>, extra2?: Dictionary<number>, discount?: boolean): number =>
{
  var parts = getConfigurationProducts(configuration, repo);
  var price = getPartsPrice(parts, repo, currency, discount);
  if(extra1) price += getPartsPrice(extra1, repo, currency, discount);
  if(extra2) price += getPartsPrice(extra2, repo, currency, discount);
  return price;
}

function getPartsPrice(parts: Dictionary<number>, repo: RepoState, currency: string, discount?: boolean) {
  return Object.keys(parts).reduce<number>((price, id) => {
    let priceKey = (discount && getDiscountPriceKey(repo, currency)) || currency;
    const product = getProduct(repo, id);
    if (product == null) return price;
    if (!product.prices[priceKey] || product.prices[priceKey] === 0) priceKey = currency;
    return price + (product.prices[priceKey] ? (product.prices[priceKey] * parts[id]) : 0);
  }, 0);
}

export const getItemPrice = (product: Product, currency: string, lang: string, amount: number = 1, discount?: boolean) => {
  const priceKey = (discount && getDiscountPriceKey({ langCode: lang }, currency)) || currency;
  const price = product.prices[priceKey] || product.prices[currency] || 0; // fallback to normal price if no discount is found
  return (isWholeNumber(price)
    ? (price * amount).toLocaleString(lang)
    : (price * amount).toLocaleString(lang, { minimumFractionDigits: 2, maximumFractionDigits: 2 }))
    + ",-";
}

export const getCurrency = (cur: string, repo: RepoState) => {
  return repo.currency.find(c => c.currency === cur)?.format ?? '{0}';
}

export const getItemsCount = (repo: RepoState, products: Dictionary<number>, accessories?: Dictionary<number>, additional?: Dictionary<number>) => {
  let total = 0;
  if (products) Object.keys(products).map(key => total += products[key]);
  if (accessories) Object.keys(accessories).map(key => total += accessories[key]);
  if (additional) Object.keys(additional).map(key => total += additional[key]);

  return total;
}

function isWholeNumber(price: number) {
  const eps = 1e-8
  return Math.abs(price % 1) < eps || Math.abs(price % 1 - 1) < eps
}

